import { render, staticRenderFns } from "./UserProvisionalReport.vue?vue&type=template&id=0e4afea9&"
import script from "./UserProvisionalReport.vue?vue&type=script&lang=js&"
export * from "./UserProvisionalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports